import { initializeFaro } from "@grafana/faro-web-sdk";
import { pushFaroQueue } from "../lib/faro/push";
import { FARO_INIT_ATTRIBUTE } from "../lib/faro/constants";
import { getFaroInitAttribute, waitForFaroInitAttributes } from "../lib/faro/init";
// The code in this file is bundled as separate asset and linked via async script tag in base-layout.html
const environment = getFaroInitAttribute(FARO_INIT_ATTRIBUTE.Environment, "prd");
const isAsyncInit = getFaroInitAttribute(FARO_INIT_ATTRIBUTE.AsyncInit) === "true";
const PATH_SAMPLE_RATE = {
    // TODO [CH]: Once we have the majority of the traffic on v2 we need to greatly increase the sample rate on v1 otherwise we won't get much data at all
    "/inline-sign-in": 0.05, // ~900k visits per day at the moment of writing
    "/inline-sign-in-v2": 0.05, // ~900k visits per day at the moment of writing
    "/quick-auth": 0.5, // ~20k visits per day at the moment of writing
};
const initFaroAndPushQueue = () => {
    initializeFaro({
        paused: ["test-e2e", "local"].indexOf(environment) !== -1,
        url: "https://faro-collector-prod-us-central-0.grafana.net/collect/40badb426e7d39b9357c93dd5c6c8fdd",
        app: {
            name: "openpass-sign-in-form",
            version: "1.0.0",
            environment,
        },
        sessionTracking: {
            session: {
                id: getFaroInitAttribute(FARO_INIT_ATTRIBUTE.SessionId),
                attributes: {
                    client_id: getFaroInitAttribute(FARO_INIT_ATTRIBUTE.ClientId),
                    account_id: getFaroInitAttribute(FARO_INIT_ATTRIBUTE.AccountId),
                    trace_id: getFaroInitAttribute(FARO_INIT_ATTRIBUTE.TraceId),
                },
            },
            sampler() {
                if (environment !== "prd") {
                    return 1;
                }
                const sampleRate = PATH_SAMPLE_RATE[location.pathname];
                return Number.isFinite(sampleRate) ? sampleRate : 1;
            },
        },
        pageTracking: {
            page: {
                // We had an issue where page_id couldn't be automatically identified for `/inline-sign-in-v2` page.
                // Specifying id as pathname explicitly fixed it (Grafana uses pathname as id for pages by default).
                id: location.pathname
            }
        }
    });
    pushFaroQueue();
};
const initFaroAsyncAndPushQueue = async () => {
    try {
        await waitForFaroInitAttributes();
        initFaroAndPushQueue();
    }
    catch (error) {
        console.error("Failed to initialize Faro:", error);
    }
};
if (isAsyncInit) {
    initFaroAsyncAndPushQueue();
}
else {
    initFaroAndPushQueue();
}
